import React from "react";
import { GeneratePdfButton } from "../swing_library/components/PdfGeneration/GeneratePdfButton";
import { PurchaseHistoryButton } from "../credits/components/PurchaseHistoryButton/PurchaseHistoryButton";

export const PdfWithCSS = () => {
  return (
    <div>
      <GeneratePdfButton
        userId="9o6lNlYzHrVTJs58wmaPVP2wzia2"
        videoIds={[
          "oHbDPVR9I7WfJ5KUjRXW",
          "yBdVFsPsm14HbjHc1rhI",
          "D7DYIvfUftjr9QBDid1i",
        ]}
        golfClub="D"
        userName="Jane Doe"
        height="4′3″"
        gender="FEMALE"
        credits={100}
        verificationClubs={[]}
        verificationUsers={[]}
        verificationCameraAngles={[]}
        verificationAnalysed={[]}
        isTest
      />
    </div>
  );
};
